import { i18n } from '@/locale/i18n'
import { syncToLocal } from '../mixins'

export default {
  namespaced: true,

  actions: {
    afterCreate (context) {
      syncToLocal(context)
    },

    beforeUpdate (context, record) {
      const recordBeforeUpdate = context.getters['projects/find'](record.id)

      if (recordBeforeUpdate) {
        // if opco or norm has been changed - unlock all locked elements
        if (recordBeforeUpdate.isLocked()) {
          if (recordBeforeUpdate.opco_id !== record.opco_id || recordBeforeUpdate.norm_id !== record.norm_id) {
            // call Project Model unlock() on recordBeforeUpdate as record doesn't have the methods
            recordBeforeUpdate.unlock()
          }
        }

        // if opco has been changed - update all product types data on each project slab
        if (recordBeforeUpdate.opco_id !== record.opco_id) {
          // get first productType of new selected OpCo
          const productTypeId = Object.keys(context.rootGetters.opcoProductTypes(record.opco_id))[0]

          const product = context.rootState.product_types[productTypeId]

          const thickness = Object.keys(product.thickness)[0]

          const widths = product.thickness[thickness].reduce((a, c) => {
            a.push(c.width)
            return a
          }, [])

          // do not reset topping_thickness, it will be resolved in slab beforeUpdate lifecycle hook anyway
          // const productData = context.rootGetters.productTypeData(productTypeId, thickness, widths[0])

          context.dispatch('slabs/update', {
            where: slab => slab.project_id === record.id,
            data: {
              floor_product_type_id: productTypeId,
              floor_thickness: thickness,
              floor_width: widths[0]
              // topping_thickness: productData.topping_thickness[0]
            }
          })

          // alert user
          uikit.notification('<span class="uk-margin-small-right" uk-icon="warning"></span>' + i18n.t('warning_changed_opco'), {
            pos: 'bottom-right',
            status: 'warning',
            timeout: 20000
          })
        }

        // it seems that there's no easy way to detect here if we need to toggle the savedOnServer as we don't know if the new value is the old one or the new one ...
        // we will try to force it in ALL updates
        /* if (recordBeforeUpdate.savedOnServer && !record.savedOnServer) {

        } */
      }
    },

    afterUpdate (context, record) {
      syncToLocal(context)
    },

    afterDelete (context, record) {
      // delete dependencies: contacts & elements (with dependencies - auto from it's lifecycle hook)
      context.dispatch('contacts/delete', contact => contact.project_id === record.id)

      context.dispatch('slabs/delete', slab => slab.project_id === record.id)

      syncToLocal(context)

      // server-side
      // if (record.id > 0) {
      uikit.util.ajax('api/project', {
        method: 'delete',
        // responseType: 'json', // this might not work with smart file result as blob
        data: JSON.stringify({
          id: record.id
        }),
        headers: {
          'Content-Type': 'application/json; charset=UTF-8',
          'X-Requested-With': 'XMLHttpRequest'
        }
      }).then(function (xhr) {
        // do nothing
      }, function (error) {
        let details = error.xhr ? JSON.parse(error.xhr.responseText).message : 'Ooops ! We\'ve encountered an error :('

        uikit.notification(`<p class="uk-h3 uk-text-danger"><span class="uk-margin-small-right" uk-icon="ban"></span>${error.message}</p><p>${details}</p>`, {pos: 'bottom-right', status: 'danger'})
      })
      // }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/projects.js